// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// Copyright (c) Utrecht University (Department of Information and Computing Sciences)

import { sound } from "@pixi/sound";
import { store } from "@/store";
import victory from "@/assets/sounds/default/farm/Victory.ogg";
import crash from "@/assets/sounds/default/farm/Crash.ogg";

let ambientsounds = [] as string[];

//Load generic game sounds
function loadGenericSounds(): void {
  sound.add("Victory", victory);
  sound.add("Crash", crash);
}

/**
 * Load sounds for specific world
 * @param name Sound name
 * @param url Sound url
 * @param ambient Ambient sound
 */
function loadWorldSounds(name: string, url: string, ambient: boolean): void {
  sound.add(name, url);
  if (ambient) {
    ambientsounds.push(name);
  }
}

/**
 * Play sound
 * @param name Sound name
 * @param loop If sound needs to be played in a loop
 * @param vol Sound volume
 */
function playSound(name: string, loop: boolean, vol: number): void {
  if (name == "Background") {
    if (store.getters.getMusicSettings) {
      sound.play(name, { loop: loop, volume: vol });
    }
  } else {
    if (store.getters.getSoundSettings) {
      sound.play(name, { loop: loop, volume: vol });
    }
  }
}

/**
 * Stop sound
 * @param name Sound name
 */
function stopSound(name: string): void {
  sound.stop(name);
}

//Set ambient sound
function ambientSounds(): void {
  const time = Math.random() * 10000;
  if (ambientsounds == []) return;

  const sound = ambientsounds[randomInt(0, ambientsounds.length - 1)];
  setTimeout(playAmbient, time, sound, false);
}

/**
 * Play ambient sound
 * @param name Sound name
 */
function playAmbient(name: string): void {
  playSound(name, false, 0.1);
  ambientSounds();
}

/**
 * Get random integer
 * @param min Minimal integer
 * @param max Maximum integer
 * @returns Random integer
 */
function randomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

//Terminate sounds
function terminateSounds(): void {
  sound.removeAll();
  ambientsounds = [];
}

export {
  loadWorldSounds,
  playSound,
  terminateSounds,
  ambientSounds,
  stopSound,
  loadGenericSounds,
};
